import React from 'react';

import PropTypes from 'prop-types';

import {
    Content,
    ContentSection,
    MarkdownContent,
    Sidebar,
    Statistic,
} from 'wanderu-components';

import localize from 'wanderu-i18n/src/localize';

import placeGuideConfig from '../../../../config/placeguide.locale';
import StatisticsContainer from '../../StatisticsContainer/StatisticsContainer';

function CheapestTicket(props) {
    const {
        i18nMoney,
        t,
        cheapestTicketData,
        className,
    } = props;

    const {
        avgPrice,
        cheapestPrice,
        cheapestAvgPrice,
        maxPrice,
        minPrice,
    } = cheapestTicketData;

    if (!Object.keys(cheapestTicketData).length) {
        return null;
    }

    return (
        <ContentSection
            className={className}
            id="place-guide-cheapest-ticket"
            title={t('cheapestTicketsTitle')}
            isCollapsable
            useAccordionComponent
        >
            <Content>
                <MarkdownContent>
                    {t('cheapestTicketsDescription', {
                        avgPrice: avgPrice
                            ? i18nMoney(avgPrice).format()
                            : '',
                        avgCheapPriceUSD: cheapestAvgPrice
                            ? i18nMoney(cheapestAvgPrice).format()
                            : '',
                        maxPrice: maxPrice
                            ? i18nMoney(maxPrice).format()
                            : '',
                        minPrice: minPrice
                            ? i18nMoney(minPrice).format()
                            : '',
                        price: cheapestPrice
                            ? i18nMoney(cheapestPrice).format()
                            : '',
                    })}
                </MarkdownContent>
            </Content>
            {cheapestPrice && (
                <Sidebar>
                    <StatisticsContainer>
                        <Statistic
                            title={t('cheapestPrice')}
                            value={i18nMoney(cheapestPrice).format()}
                        />
                    </StatisticsContainer>
                </Sidebar>
            )}
        </ContentSection>
    );
}

CheapestTicket.propTypes = {
    cheapestTicketData: PropTypes.shape({
        avgPrice: PropTypes.number,
        cheapestPrice: PropTypes.number,
        cheapestAvgPrice: PropTypes.number,
        maxPrice: PropTypes.number,
        minPrice: PropTypes.number,
    }),
    className: PropTypes.string,
};
CheapestTicket.defaultProps = {
    className: '',
    cheapestTicketData: {},
};

export { CheapestTicket };
export default localize(CheapestTicket, placeGuideConfig.namespace);
